/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { useHistory, useLocation } from 'react-router-dom';
import { Grid, TableCell, TableRow } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import MUITableLoading from 'components/MUITableLoading/MUITableLoading';
import Layout from 'components/Layout/Layout';
import { EQueryStringKey } from 'services/QueryString/QueryStringService';
import { LIST_BRANDS_WITH_CHILDREN } from '../../../../queries/products/brand';
import DrawerNative from '../../../../components/DrawerNative';
import PageError from '../../../../components/PageError';
import PageTitle from '../../../../components/PageTitle/PageTitle';
import { Update } from './edit';
import { AddBrands } from './create';
import DeleteBrands from './delete';
import useStyles from './style';
import BrandLinkName from '../components/BrandLinkName';
import CustomBrandSearch from '../components/CustomBrandSearch';

export default function BrandsContent() {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState('');
  const [brands, setBrands] = useState([]);
  const queryBrands = useQuery(LIST_BRANDS_WITH_CHILDREN, {
    fetchPolicy: 'cache-and-network',
  });
  const { loading, error, refetch } = queryBrands;
  const refetchBrands = refetch;

  useEffect(() => {
    if (queryBrands.data) {
      const { data } = queryBrands;
      setBrands(data.brandsWithChildren);
    }
  }, [queryBrands]);

  const toolbar = (selectedRows) => (
    <Grid
      container
      spacing={0}
      item
      xs={9}
      alignItems="flex-start"
      justify="flex-end"
      direction="row"
    >
      <Grid item xs={1}>
        <DeleteBrands
          selectedRows={selectedRows}
          brands={brands}
          refetch={refetchBrands}
        />
      </Grid>
    </Grid>
  );

  const handleOpenUpdateBrandDrawer = (brandId) => {
    setSelectedBrandId(brandId);
    setIsUpdateDrawerOpen(true);

    const params = new URLSearchParams({ [EQueryStringKey.BrandId]: brandId });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const handleCloseUpdateBrandDrawer = () => {
    setSelectedBrandId('');
    setIsUpdateDrawerOpen(false);

    const params = new URLSearchParams(location.search);
    params.delete(EQueryStringKey.BrandId);
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const linkBrandName = (brandId, brandName) => {
    return (
      <BrandLinkName
        id={brandId}
        name={brandName}
        onClick={() => handleOpenUpdateBrandDrawer(brandId)}
        className={classes.linkBrandName}
      />
    );
  };

  useEffect(() => {
    let mounted = true;

    const brandIdQueryString = new URLSearchParams(location.search).get(
      EQueryStringKey.BrandId,
    );

    if (mounted && brandIdQueryString && !isUpdateDrawerOpen) {
      handleOpenUpdateBrandDrawer(brandIdQueryString);
    }

    return () => (mounted = false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      name: 'name',
      label: 'NAME ([previous name])',
      options: {
        customBodyRender: (value, tableMeta) => {
          const name = tableMeta.rowData[0];
          const id = tableMeta.rowData[1];

          return linkBrandName(id, name);
        },
        empty: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: 'id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'website',
      label: 'WEBSITE',
      options: {
        display: true,
      },
    },
    {
      name: 'address',
      label: 'ADDRESS',
      options: {
        display: true,
      },
    },
    {
      name: 'state',
      label: 'STATE',
      options: {
        display: true,
      },
    },
    {
      name: 'country',
      label: 'COUNTRY',
      options: {
        display: true,
      },
    },
    {
      name: 'phoneNumber',
      label: 'PHONE NUMBER',
      options: {
        display: true,
      },
    },
    {
      name: 'parent',
      label: 'PARENT',
      options: {
        display: false,
      },
    },
    {
      name: 'children',
      label: 'CHILDREN',
      options: {
        display: false,
      },
    },
  ];

  const options = {
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    responsive: 'standard',
    searchOpen: true,
    searchAlwaysOpen: true,
    customToolbarSelect: toolbar,
    expandableRows: true,
    rowsExpanded: brands.map((el, i) => i),
    customSearchRender: (searchText, handleSearch) => {
      return (
        <CustomBrandSearch searchText={searchText} onSearch={handleSearch} />
      );
    },
    renderExpandableRow: (rowData) => {
      const brandChildren = rowData[8];
      const childrenParentId = rowData[1];

      return brandChildren.map((child) => {
        const childWithParent = {
          ...child,
          parent: {
            id: childrenParentId,
          },
        };

        return (
          <TableRow>
            <TableCell />
            <TableCell>
              <div style={{ display: 'flex', columnGap: '4px' }}>
                {'——'}
                {linkBrandName(childWithParent.id, childWithParent.name)}
              </div>
            </TableCell>
            <TableCell>{childWithParent.website}</TableCell>
            <TableCell>{childWithParent.address}</TableCell>
            <TableCell>{childWithParent.state}</TableCell>
            <TableCell>{childWithParent.country}</TableCell>
            <TableCell>{childWithParent.phoneNumber}</TableCell>
          </TableRow>
        );
      });
    },
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Brands" />
        </Grid>
        <Grid item xs={2}>
          <DrawerNative title="Brands" labelButtonAction="Add" showBtn2>
            <AddBrands
              refetch={refetchBrands}
              onCloseDrawer={handleCloseUpdateBrandDrawer}
            />
          </DrawerNative>
        </Grid>
      </Grid>

      <DrawerNative
        title="Edit Brands"
        iconButtonAction={false}
        open={isUpdateDrawerOpen}
        onCloseDrawer={handleCloseUpdateBrandDrawer}
        showBtn2
      >
        <Update
          id={selectedBrandId}
          refetchList={refetchBrands}
          onCloseDrawer={handleCloseUpdateBrandDrawer}
        />
      </DrawerNative>

      {loading ? (
        <MUITableLoading
          columns={[
            'NAME',
            'WEBSITE',
            'ADDRESS',
            'STATE',
            'COUNTRY',
            'PHONE NUMBER',
            'PREVIOUS NAME',
          ]}
        />
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MUIDataTable
              title={false}
              data={brands}
              columns={columns}
              options={options}
            />
          </Grid>
        </Grid>
      )}
    </Layout>
  );
}
